<template>
  <a-select
    v-model:value="value"
    placeholder="推广产品"
    style="width: 100%"
    :allowClear="true"
    show-search
    :options="suggestionData"
    @change="onChange"
  ></a-select>
</template>
<script lang='ts' setup>
import { defineProps, defineEmits, computed } from 'vue';
import { useStore } from 'vuex'

const store = useStore()

const suggestionData: any = computed(() => store.state.platforms)

const props = defineProps({
  modelValue: {
    type: String,
  },
})

const emits = defineEmits(['update:modelValue'])

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})

const onChange = (item, options) => {
  if (item) {
    emits('update:modelValue', item)
  }
}
</script>
<style lang='scss' scoped>

</style>